const replaceSpacingWithNoBreakSpacingForFrench = (value) =>
  value
    ? value
        .replaceAll(' : ', `\xa0:\xa0`)
        .replaceAll('  »', `\xa0\xa0»`)
        .replaceAll('«  ', `«\xa0\xa0`)
    : '';

export default replaceSpacingWithNoBreakSpacingForFrench;
